const AccountIcon = ({ className, width = 12, height = 14 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00038 7.06001C4.30038 7.06001 2.90038 5.67999 2.90038 3.96001C2.90038 2.24001 4.30038 0.880005 6.00038 0.880005C7.70038 0.880005 9.10038 2.26002 9.10038 3.98C9.10038 5.69999 7.70038 7.06001 6.00038 7.06001ZM6.00038 1.48C4.62036 1.48 3.50038 2.59999 3.50038 3.98C3.50038 5.36002 4.62036 6.48001 6.00038 6.48001C7.38039 6.48001 8.50038 5.36002 8.50038 3.98C8.50038 2.59999 7.38039 1.48 6.00038 1.48ZM0.680375 12.74C1.30036 10.14 3.48038 8.30001 6.00038 8.30001C8.52038 8.30001 10.7004 10.12 11.3204 12.74L11.4004 13.1H0.580389L0.680375 12.74ZM10.6404 12.52C9.98034 10.38 8.12038 8.92002 6.00038 8.92002C3.88038 8.92002 2.02038 10.3801 1.36038 12.52H10.6404Z"
      fill="black"
    />
  </svg>
);

const CartIcon = ({ className, width = 12, height = 16 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.53983 5.88001H2.5798V4.12001C2.5798 2.24001 4.11977 0.700012 5.9998 0.700012C7.8798 0.700012 9.4198 2.23998 9.4198 4.12001V5.88001H10.4598C11.1797 5.88001 11.7598 6.46003 11.7598 7.18001V14.02C11.7598 14.74 11.1797 15.32 10.4598 15.32H1.51977C0.799783 15.32 0.219766 14.74 0.219766 14.02L0.219831 7.18001C0.239818 6.46003 0.819832 5.88001 1.53981 5.88001H1.53983ZM8.81983 4.12001C8.81983 2.55998 7.5598 1.30001 5.99983 1.30001C4.4398 1.30001 3.17983 2.56005 3.17983 4.12001V5.88001H8.81983V4.12001ZM0.839833 14.02C0.839833 14.4 1.15982 14.72 1.53983 14.72H10.4598C10.8398 14.72 11.1598 14.4 11.1598 14.02V7.18001C11.1598 6.8 10.8398 6.48001 10.4598 6.48001H9.41987V8.94001H8.81987L8.8198 6.48001H3.1798V8.94001H2.5798V6.48001H1.53983C1.15982 6.48001 0.839834 6.8 0.839834 7.18001L0.839833 14.02Z"
      fill="black"
    />
  </svg>
);

const WishlistIcon = ({ className, width = 16, height = 14 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99954 13.92L14.2995 7.58001C15.1195 6.76003 15.5596 5.68001 15.5596 4.52001C15.5596 3.35998 15.1196 2.28001 14.2995 1.46001C12.6195 -0.219988 9.87954 -0.219988 8.19954 1.46001L7.99954 1.66001L7.79954 1.46001C6.11954 -0.219988 3.37954 -0.219988 1.69954 1.46001C0.019536 3.14001 0.019536 5.88001 1.69954 7.56001L7.99954 13.92ZM11.2595 0.820012C12.2196 0.820012 13.1595 1.18005 13.8795 1.90003C15.3195 3.34 15.3195 5.70003 13.8795 7.16003L7.99954 13.06L2.11954 7.16003C0.67957 5.72006 0.67957 3.36003 2.11954 1.90003C3.5595 0.460062 5.91954 0.460062 7.37954 1.90003L7.99952 2.52001L8.6195 1.90003C9.33949 1.18005 10.2995 0.820012 11.2595 0.820012H11.2595Z"
      fill="black"
    />
  </svg>
);

const SearchIcon = ({ className, width = 12, height = 12 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.695 11.435L8.59499 8.355C10.415 6.415 10.375 3.355 8.475 1.455C6.535 -0.485 3.395 -0.485 1.455 1.455C-0.485 3.395 -0.485 6.535 1.455 8.475C2.41503 9.43503 3.695 9.93503 4.975 9.93503C6.11497 9.93503 7.255 9.55502 8.175 8.775L11.275 11.875L11.695 11.435ZM1.89499 8.055C0.194987 6.355 0.194987 3.575 1.89499 1.875C2.75502 1.01497 3.85499 0.594984 4.97499 0.594984C6.09499 0.594984 7.21499 1.01497 8.05499 1.875C9.75499 3.575 9.75499 6.355 8.05499 8.055C6.35499 9.755 3.59499 9.755 1.89499 8.055Z"
      fill="black"
    />
  </svg>
);

const BurgerIcon = ({ className, width = 16, height = 14 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.579013 0.720531H0.570992C0.255472 0.720531 5.72205e-06 0.976052 5.72205e-06 1.29152C5.72205e-06 1.60704 0.255526 1.8625 0.570992 1.8625H0.579482H15.4208H15.4288C15.7444 1.8625 15.9998 1.60698 15.9998 1.29152C15.9998 0.975998 15.7443 0.720531 15.4288 0.720531H15.4203H0.579013ZM0.579013 6.42906H0.570992C0.255472 6.42906 5.72205e-06 6.68459 5.72205e-06 7.00005C5.72205e-06 7.31557 0.255526 7.57104 0.570992 7.57104H0.579482H15.4208H15.4288C15.7444 7.57104 15.9998 7.31552 15.9998 7.00005C15.9998 6.68453 15.7443 6.42906 15.4288 6.42906H15.4203H0.579013ZM0.579013 12.1376H0.570992C0.255472 12.1376 5.72205e-06 12.3931 5.72205e-06 12.7086C5.72205e-06 13.0241 0.255526 13.2796 0.570992 13.2796H0.579482H15.4208H15.4288C15.7444 13.2796 15.9998 13.0241 15.9998 12.7086C15.9998 12.3931 15.7443 12.1376 15.4288 12.1376H15.4203H0.579013Z"
      fill="black"
    />
  </svg>
);

const CloseIcon = ({ className, width = 12, height = 12, fill = 'black' }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23_1150)">
      <path
        d="M0.364454 11.9999C0.267892 12.0013 0.175074 11.9614 0.109454 11.8906C0.0405481 11.8222 0.00164413 11.7289 0.00164413 11.6319C0.00164413 11.5349 0.0405501 11.4416 0.109454 11.3731L11.3815 0.109134C11.4475 0.0388219 11.5399 -0.00102615 11.6365 -0.00102615C11.733 -0.00102615 11.8254 0.0388179 11.8915 0.109134C11.9618 0.175228 12.0016 0.267574 12.0016 0.364134C12.0016 0.460694 11.9618 0.553044 11.8915 0.619134L0.619454 11.8911C0.553829 11.9619 0.461014 12.0018 0.364454 12.0004V11.9999Z"
        fill={fill}
      />
      <path
        d="M11.6568 11.9998C11.5602 12.0012 11.4679 11.9613 11.4018 11.8905L0.108806 0.61855C0.0384938 0.552456 -0.00135422 0.46011 -0.00135422 0.36355C-0.00135422 0.26699 0.0384898 0.17464 0.108806 0.10855C0.1749 0.0382382 0.267246 -0.0016098 0.363806 -0.0016098C0.460366 -0.0016098 0.552716 0.0382342 0.618806 0.10855L11.8908 11.3725C11.9597 11.441 11.9986 11.5343 11.9986 11.6313C11.9986 11.7283 11.9597 11.8216 11.8908 11.89C11.8303 11.9552 11.7464 11.9946 11.6574 11.9993L11.6568 11.9998Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_23_1150">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ChevronIcon = ({ className, width = 8, height = 4, fill = 'black' }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.28611 0L4.01227 2.81864L0.68919 0.062176L0 0.663227L4.03692 4L8 0.580326L7.28611 0Z"
      fill={fill}
    />
  </svg>
);

const CheckIcon = ({ className, width = 14, height = 14 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M1.5 7.5L5.25 11.25L12.5 3" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const InfoIcon = ({ className, width = 20, height = 20 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.5" cy="9.5" r="8.5" fill="#000000" />
    <path
      d="M10.5 0C5.25315 0 1 4.25315 1 9.5C1 14.7469 5.25315 19 10.5 19C15.7469 19 20 14.7469 20 9.5C20 4.25315 15.7469 0 10.5 0ZM10.5 14.25C9.9756 14.25 9.55 13.8244 9.55 13.3V9.5C9.55 8.9756 9.9756 8.55 10.5 8.55C11.0244 8.55 11.45 8.9756 11.45 9.5V13.3C11.45 13.8244 11.0244 14.25 10.5 14.25ZM10.975 6.65H10.025C9.7628 6.65 9.55 6.4372 9.55 6.175V5.225C9.55 4.9628 9.7628 4.75 10.025 4.75H10.975C11.2372 4.75 11.45 4.9628 11.45 5.225V6.175C11.45 6.4372 11.2372 6.65 10.975 6.65Z"
      fill="#F5F5F5"
    />
  </svg>
);

const ArrowIcon = ({ className, width = 11, height = 9, fill = 'black' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 11 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3536 4.85355C10.5488 4.65829 10.5488 4.34171 10.3536 4.14645L7.17157 0.964466C6.97631 0.769204 6.65973 0.769204 6.46447 0.964466C6.2692 1.15973 6.2692 1.47631 6.46447 1.67157L9.29289 4.5L6.46447 7.32843C6.2692 7.52369 6.2692 7.84027 6.46447 8.03553C6.65973 8.2308 6.97631 8.2308 7.17157 8.03553L10.3536 4.85355ZM0 5L10 5V4L0 4L0 5Z"
      fill={fill}
    />
  </svg>
);

const TagIcon = ({ className, width = 40, height = 40, fill = 'white' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke={fill} />
    <path
      d="M21.2189 12.0265L19.8253 12.0282L19.8156 19.7926L11.9976 19.81L11.9959 21.1883L19.8138 21.1862L19.8041 28.9965L21.1977 28.9947L21.2074 21.1844L28.9718 21.1747L28.9735 19.7811L21.2092 19.7908L21.2189 12.0265Z"
      fill={fill}
    />
  </svg>
);

const ShippingIcon = ({ className, width = 55, height = 55, fill = '#bababa' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 6H3V17.25H3.375H4.5H4.52658C4.70854 18.5221 5.80257 19.5 7.125 19.5C8.44743 19.5 9.54146 18.5221 9.72342 17.25H15.0266C15.2085 18.5221 16.3026 19.5 17.625 19.5C18.9474 19.5 20.0415 18.5221 20.2234 17.25H21.75V12.4393L18.3107 9H16.5V6ZM16.5 10.5V14.5026C16.841 14.3406 17.2224 14.25 17.625 14.25C18.6721 14.25 19.5761 14.8631 19.9974 15.75H20.25V13.0607L17.6893 10.5H16.5ZM15 15.75V9V7.5H4.5V15.75H4.75261C5.17391 14.8631 6.07785 14.25 7.125 14.25C8.17215 14.25 9.07609 14.8631 9.49739 15.75H15ZM17.625 18C17.0037 18 16.5 17.4963 16.5 16.875C16.5 16.2537 17.0037 15.75 17.625 15.75C18.2463 15.75 18.75 16.2537 18.75 16.875C18.75 17.4963 18.2463 18 17.625 18ZM8.25 16.875C8.25 17.4963 7.74632 18 7.125 18C6.50368 18 6 17.4963 6 16.875C6 16.2537 6.50368 15.75 7.125 15.75C7.74632 15.75 8.25 16.2537 8.25 16.875Z"
      fill={fill}
    />
  </svg>
);

const GiftIcon = ({ className, width = 40, height = 40, fill = '#bababa' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 1040 1040"
    fill={fill}
    stroke={fill}
    strokeWidth="30"
  >
    <path d="M880.64 463.33c16.962 0 30.72-13.758 30.72-30.72v-56.013c0-16.962-13.758-30.72-30.72-30.72H143.36c-16.962 0-30.72 13.758-30.72 30.72v56.013c0 16.962 13.758 30.72 30.72 30.72h737.28zm0 40.96H143.36c-39.583 0-71.68-32.097-71.68-71.68v-56.013c0-39.583 32.097-71.68 71.68-71.68h737.28c39.583 0 71.68 32.097 71.68 71.68v56.013c0 39.583-32.097 71.68-71.68 71.68z" />
    <path d="M184.32 908.481c0 16.962 13.758 30.72 30.72 30.72h593.92c16.962 0 30.72-13.758 30.72-30.72V504.144H184.32v404.337zm624.64 71.68H215.04c-39.583 0-71.68-32.097-71.68-71.68V463.184h737.28v445.297c0 39.583-32.097 71.68-71.68 71.68z" />
    <path d="M491.52 326.681v645.12h40.96v-645.12z" />
    <path d="M490.883 292.319v-66.324c0-85.222-69.095-154.317-154.317-154.317h-24.207c-28.912 0-52.357 23.445-52.357 52.357v24.207c0 85.222 69.095 154.317 154.317 154.317h66.324c5.585 0 10.24-4.655 10.24-10.24zm40.96 0c0 28.207-22.993 51.2-51.2 51.2h-66.324c-107.843 0-195.277-87.434-195.277-195.277v-24.207c0-51.534 41.784-93.317 93.317-93.317h24.207c107.843 0 195.277 87.434 195.277 195.277v66.324z" />
    <path d="M491.301 292.319v-66.324c0-107.843 87.434-195.277 195.277-195.277h24.207c51.534 0 93.317 41.784 93.317 93.317v24.207c0 107.843-87.434 195.277-195.277 195.277h-66.324c-28.207 0-51.2-22.993-51.2-51.2zm40.96 0c0 5.585 4.655 10.24 10.24 10.24h66.324c85.222 0 154.317-69.095 154.317-154.317v-24.207c0-28.912-23.445-52.357-52.357-52.357h-24.207c-85.222 0-154.317 69.095-154.317 154.317v66.324z" />
  </svg>
);

const TrashIcon = ({ className, width = 20, height = 20, fill = '#3C3C3B' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M20.5001 6H3.5" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M18.8332 8.5L18.3732 15.3991C18.1962 18.054 18.1077 19.3815 17.2427 20.1907C16.3777 21 15.0473 21 12.3865 21H11.6132C8.95235 21 7.62195 21 6.75694 20.1907C5.89194 19.3815 5.80344 18.054 5.62644 15.3991L5.1665 8.5"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.1709 4C9.58273 2.83481 10.694 2 12.0002 2C13.3064 2 14.4177 2.83481 14.8295 4"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const LoadingIcon = ({ className, width = 24, height = 30 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0" y="0" width="4" height="10" fill="currentColor">
      <animateTransform
        attributeType="xml"
        attributeName="transform"
        type="translate"
        values="0 0; 0 20; 0 0"
        begin="0"
        dur="0.6s"
        repeatCount="indefinite"
      />
    </rect>
    <rect x="10" y="0" width="4" height="10" fill="currentColor">
      <animateTransform
        attributeType="xml"
        attributeName="transform"
        type="translate"
        values="0 0; 0 20; 0 0"
        begin="0.2s"
        dur="0.6s"
        repeatCount="indefinite"
      />
    </rect>
    <rect x="20" y="0" width="4" height="10" fill="currentColor">
      <animateTransform
        attributeType="xml"
        attributeName="transform"
        type="translate"
        values="0 0; 0 20; 0 0"
        begin="0.4s"
        dur="0.6s"
        repeatCount="indefinite"
      />
    </rect>
  </svg>
);

const Icon = ({ type, width, heigth, className, fill }) => {
  switch (type) {
    case 'account':
      return <AccountIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'cart':
      return <CartIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'wishlist':
      return <WishlistIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'search':
      return <SearchIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'burger':
      return <BurgerIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'close':
      return <CloseIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'chevron':
      return <ChevronIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'check':
      return <CheckIcon className={className} width={width} height={heigth} />;
    case 'info':
      return <InfoIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'arrow':
      return <ArrowIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'tag':
      return <TagIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'gift':
      return <GiftIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'shipping':
      return <ShippingIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'trash':
      return <TrashIcon className={className} width={width} height={heigth} fill={fill} />;
    case 'loading':
      return <LoadingIcon className={className} width={width} height={heigth} />;
    default:
      return null;
  }
};

export default Icon;
